// NOTICE: KAPTION-INTEGRATION
// partner-provisioning.PORTAL.6 — the partner panel is account-less.
//
// These routes deliberately sit OUTSIDE `accounts/:accountId`: a partner
// staffer may hold no account at all, and the panel is not part of the
// conversational interface. routeHelpers skips account resolution for them
// (see validateLoggedInRoutes) and the router lands account-less users here.
import { frontendURL } from '../../../helper/URLHelper';

const PanelLayout = () => import('./PanelLayout.vue');
const Index = () => import('./Index.vue');
const NewAccount = () => import('./NewAccount.vue');
const AccountDetail = () => import('./AccountDetail.vue');
const Docs = () => import('./Docs.vue');

const permissions = ['administrator', 'agent', 'custom_role'];

// Every panel route name starts with this, so one prefix test covers them all.
export const PARTNER_PANEL_ROUTE_PREFIX = 'kaption_partner';

export const isKaptionPartnerPanelRoute = routeName =>
  typeof routeName === 'string' &&
  routeName.startsWith(PARTNER_PANEL_ROUTE_PREFIX);

export const routes = [
  {
    path: frontendURL('partner'),
    component: PanelLayout,
    meta: { permissions },
    children: [
      {
        path: '',
        name: 'kaption_partner_index',
        meta: { permissions },
        component: Index,
      },
      {
        path: 'accounts/new',
        name: 'kaption_partner_new_account',
        meta: { permissions },
        component: NewAccount,
      },
      {
        path: 'accounts/:partnerAccountId',
        name: 'kaption_partner_account',
        meta: { permissions },
        component: AccountDetail,
      },
      {
        // partner-provisioning.PORTAL.7
        path: 'docs',
        name: 'kaption_partner_docs',
        meta: { permissions },
        component: Docs,
      },
    ],
  },
];
